/* eslint-disable enforce-ids-in-jsx/missing-ids */
import React from 'react'

import CenteredLoader from 'components/lib/CenteredLoader'

import CampaignCard from './components/CampaignCard'
import CardsLoadingPlaceholder from './components/CardsLoadingPlaceholder'
import NoResultsState from './components/NoResultsState'
import SuccessState from './components/SuccessState'
import { Container } from './styles'
import useCardSection from './useCardSection'

const CardSection = ({ setIsQuickLaunchModalOpen, forceLoader = false }) => {
  const {
    campaignsData,
    excludedParticipants,
    getParticipantDuplicateState,
    placeholderFilter,
    expandedCampaignId,
    setSentinelNode,
    isMobile,
    data,
    setExcludedParticipant,
    toggleAllParticipants,
    claimAllParticipantsForCampaign,
    setSelectedCampaign,
    toggleDetails,
    isValidUntilExpired,
    launchSimulation,
  } = useCardSection({ setIsQuickLaunchModalOpen })

  let content = null

  if (campaignsData.loader || forceLoader) {
    content = <CenteredLoader style={{ height: 'calc(100vh - 396px)' }} />
  } else if (campaignsData.items.length) {
    content = campaignsData.items.map((campaign, i) => (
      <CampaignCard
        key={campaign.id}
        campaign={campaign}
        isExpanded={expandedCampaignId === campaign.id}
        isSelected={campaignsData.selectedCampaigns.includes(campaign.id)}
        isMobile={isMobile}
        isExpired={isValidUntilExpired(campaign.expiresAt)}
        participantsData={data[i]}
        excludedParticipantsForCampaign={excludedParticipants[campaign.id] || []}
        getParticipantDuplicateState={getParticipantDuplicateState}
        setExcludedParticipant={setExcludedParticipant}
        toggleAllParticipants={toggleAllParticipants}
        onClaimAllParticipants={claimAllParticipantsForCampaign}
        onToggleDetails={toggleDetails}
        onSelectCampaign={setSelectedCampaign}
        onLaunchSimulation={launchSimulation}
      />
    ))
  } else if (placeholderFilter) {
    content = <NoResultsState />
  } else {
    content = <SuccessState />
  }

  return (
    <Container>
      {content}
      <div ref={setSentinelNode} />
      {campaignsData.loadMoreLoader && <CardsLoadingPlaceholder />}
    </Container>
  )
}

export default CardSection
